import { TableColumn } from "react-data-table-component";
import { DataRow } from "./types";
import { TableCell } from "pages/UserDetails/components/UserInfo/components/TreatmentHistoryTable/styles";
import { isInTimeWindow } from "../../utils/date-utils";

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function difference(row: any) {
  const PlaylistData = row?.playlists;
  const ActivePlaylist = PlaylistData?.find(
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (item: any) => item?.isActive === true
  );

  const Activename = ActivePlaylist?.title;

  return Activename ? Activename : "-";
}

export function status(row: DataRow) {
  switch (row.latest_program_type) {
    case "maintenance":
      return "Maintenance";
    case "intensive":
      return "Intensive";
    default:
      return "Inactive";
  }
}

function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

function isTomorrow(date1: Date, date2: Date): boolean {
  const tomorrow = new Date(date2);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return isSameDay(date1, tomorrow);
}

function formatCallDate(nextCall?: string): string {
  if (!nextCall) {
    return "-";
  }
  const callTime = new Date(Date.parse(nextCall));

  const now = new Date();
  const nextTimeInUserTz = new Date(callTime.toLocaleString("en-US"));
  const nowInUserTz = new Date(now.toLocaleString("en-US"));

  // Format time
  const timeString = callTime
    .toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .toLowerCase();

  // Determine day string
  let dayString: string;
  if (isSameDay(nextTimeInUserTz, nowInUserTz)) {
    dayString = "Today";
  } else if (isTomorrow(nextTimeInUserTz, nowInUserTz)) {
    dayString = "Tomorrow";
  } else {
    dayString = callTime.toLocaleString("en-US", {
      weekday: "long",
    });
  }

  return `${dayString}, ${timeString}`;
}

export const USERS_TABLE_COLUMNS: TableColumn<DataRow>[] = [
  {
    name: "Account ID",
    selector: (row) => row.id,
    sortable: true,
    sortField: "id",
  },
  {
    name: "Full Name",
    selector: (row) => row.fullName,
    sortable: true,
    sortField: "fullName",
  },
  {
    name: "Mt Name",
    selector: (row) => row.specialist?.firstName ?? "",
    sortField: "specialist.firstName",
    sortable: true,
  },

  {
    name: "Program Week",
    selector: (row) => {
      const title = row?.programDuration ?? "";
      return title.replace(/week\s*/i, "");
    },
    sortable: false,
  },
  {
    name: "Program",
    selector: (row) =>
      row?.deletedAt ? "-" : row?.latestProgram?.program_type ?? "Inactive",
    cell: (row) => (
      <TableCell>
        {row.deletedAt
          ? "-"
          : (isInTimeWindow(
              new Date(),
              row.latestProgram?.start_date
                ? new Date(row.latestProgram?.start_date)
                : undefined,
              row.latestProgram?.end_date
                ? new Date(row.latestProgram?.end_date)
                : undefined
            ) &&
              row.latestProgram?.program_type?.toLowerCase()) ||
            "Inactive"}
      </TableCell>
    ),
  },
  {
    name: "Playlist Status",
    selector: (row) => row?.latest_program_type_status ?? "-",
    cell: (row) => (
      <TableCell>
        {row?.latest_program_type === "intensive" ? (
          <>
            {row?.latest_program_type_status
              ? row?.latest_program_type_status.toLowerCase()
              : "-"}
          </>
        ) : (
          "-"
        )}
      </TableCell>
    ),
  },

  {
    name: "Next Scheduled Call",
    selector: (row) => formatCallDate(row.nextScheduledCall),
    cell: (row) => formatCallDate(row.nextScheduledCall),
    sortable: true,
    sortField: "nextScheduledCall",
  },
];
